export default __webpack_public_path__ + "static/media/Praveen Kumar.d2b04ba9.jpg";